export default __webpack_public_path__ + "static/logo-color-blue-9cbd89e690af85b65a21a452a59681c2.svg";